import { TaskTypeStatus } from '@econtractor/types';
import { useTranslation } from 'react-i18next';

const LEGEND_STATUSES = [
    { status: TaskTypeStatus.NEW, tone: 'new' },
    { status: TaskTypeStatus.INWORK, tone: 'inwork' },
    { status: TaskTypeStatus.COMPLETED, tone: 'completed' },
    { status: TaskTypeStatus.ACCEPTED, tone: 'accepted' },
] as const;

const TaskCalendarLegend = () => {
    const { t } = useTranslation(['Tasks']);

    return (
        <div
            className="task-calendar-legend d-flex flex-wrap align-items-center gap-3"
            role="list"
            aria-label={t('calendar.legend')}
        >
            {LEGEND_STATUSES.map((item) => (
                <div
                    key={item.status}
                    className="task-calendar-legend__item d-inline-flex align-items-center gap-1"
                    role="listitem"
                >
                    <span
                        className={`task-calendar-legend__swatch task-calendar-legend__swatch--${item.tone}`}
                        aria-hidden="true"
                    />
                    <span className="text-muted">{t(`status.${item.status}`)}</span>
                </div>
            ))}
        </div>
    );
};

export default TaskCalendarLegend;
